enum FeatureEnum {
  AFFILIATION = "affiliation",
  CRYPTO = "crypto",
  PORTALS = "portals",
  PSP_PORTAL = "psp_portal",
  CREATE_ACCOUNTS = "create_accounts",
}

interface Feature {
  name: string;
  value: FeatureEnum;
}

interface EnumValue {
  name: string;
  value: string;
}

interface OnboardingStage {
  name: string;
  value: string;
  help_text: string;
}

export { FeatureEnum, Feature, EnumValue, OnboardingStage };
